import { useHistory, useParams, useLocation } from "react-router-dom";
import { Route } from "react-router-dom";

import Button from "components/global/Button";
import ConfirmModal from "components/global/ConfirmModal";
import ImgWrapper from "components/global/ImgWrapper";
import Loader from "components/global/Loader";
import Spacer from "components/global/Spacer";
import { connect } from "react-redux";
import facebookIcon from "assets/icons/facebookIcon.svg";
import facebookIconCircle from "assets/icons/facebookIconCircle.svg";
import instagramIcon from "assets/icons/instagramIcon.svg";
import instagramIconCircle from "assets/icons/instagramDefault.svg";
import linkedinIcon from "assets/icons/linkedinIcon.svg";
import linkedinIconCircle from "assets/icons/linkedinIconCircle.svg";
import twitterIcon from "assets/icons/twitterIcon.svg";
import twitterIconCircle from "assets/icons/twitterIconCircle.svg";
import tiktokCircle from "assets/icons/tiktok-circle.svg";
import tiktokIcon from "assets/icons/tiktokIcon.svg";
import { useClickOutside } from "webrix/hooks";
import userIcon from "assets/icons/userIconWhite.svg";
import youtubeIcon from "assets/icons/youtubeIcon.svg";
import youtubeIconCircle from "assets/icons/youtubeIconCircle.svg";
import ConnectChannelIllus from "assets/images/connect-channel-eng.png";
import { ManageChannelsWrapper } from "./ManageChannelsStyles";
import SelectAccountModal from "./SelectAccountModal";
import useManageChannels from "hooks/useManageChannels";
import usePageTitle from "hooks/usePageTitle";
import Channels from "./Channels";
import GoBack from "components/global/GoBack";
import { setRedirectUrl, trackEvents } from "api";
import {
  ConnectChecklist,
  ConnectFacebookInfo,
  ConnectGuide,
  ConnectTiktokInfo,
  ConnectToIgPrompt,
  InstagramAccountConvertInfo,
  RequestCall,
} from "./ChannelInfoModals";
import { useEffect, useState } from "react";
import ConnectionFailureModal from "./ConnectionFailureModal";
import EngagementModal from "components/global/engagementModals/EngagementModal";
import pinterest from "assets/icons/pinterest-icon.svg";
import threadIcon from "assets/icons/threads-icon.svg";

export const socialIcons = {
  default: {
    facebook: facebookIcon,
    twitter: twitterIcon,
    linkedin: linkedinIcon,
    youtube: youtubeIcon,
    instagram: instagramIcon,
    tiktok: tiktokIcon,
    pinterest: pinterest,
    threads: threadIcon,
    meta_threads: threadIcon,
  },
  circle: {
    facebook: facebookIconCircle,
    twitter: twitterIconCircle,
    linkedin: linkedinIconCircle,
    youtube: youtubeIconCircle,
    instagram: instagramIconCircle,
    tiktok: tiktokCircle,
    pinterest: pinterest,
    threads: threadIcon,
    meta_threads: threadIcon,
  },
};

export const ConnectedOptions = ({
  handleRefresh,
  handleRemove,
  toggleShowOptions,
  dataId,
  channel,
}) => {
  const ref = useClickOutside(() => toggleShowOptions(""));

  return (
    <div
      ref={ref}
      className="options open"
      data-id={dataId}
    >
      <button
        type="button"
        className="actionBtn textLeft"
        onClick={() => handleRefresh(channel)}
        // disabled={account.is_access_token_valid}
      >
        Refresh connection
      </button>
      <button
        type="button"
        className="actionBtn textLeft"
        onClick={() => handleRemove(channel)}
      >
        Remove channel
      </button>
    </div>
  );
};

const ManageChannels = ({
  redirect_url,
  active_account,
  current_sub,
  active_brand,
}) => {
  usePageTitle("Manage channels");
  const { search } = useLocation();
  const success = new URLSearchParams(search).get("success");
  const isBrandActive = !!active_brand.status;
  const [showEngagementModal, setShowEngagementModal] = useState(false);
  const router = useHistory();
  const { brandId } = useParams();
  const {
    loadSocials,
    socials,
    brand,
    platformList,
    removeSocial,
    handleRemoveChannel,
    toggleShowOptions,
    openOptionId,
    handleTokenRefresh,
    handleConnectPlatform,
    loading,
    connecting,
    showYoutubeModal,
    setShowYoutubeModal,
  } = useManageChannels(brandId);

  const path = `/dashboard/brands/${brandId}/channels`;

  const trackConnectChannel = async () => {
    const data = {
      event_name: "connect_channel",
      event_properties: {
        date: new Date(),
        social_media: platformList,
        account_type: current_sub?.plan_name,
        user_type: active_account?.industry,
      },
    };

    try {
      await trackEvents(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (success) {
      trackConnectChannel();
    }
    // eslint-disable-next-line
  }, [success]);

  if (!isBrandActive) {
    router.push("/dashboard/brands");
  }

  return (
    <ManageChannelsWrapper>
      {showEngagementModal && (
        <EngagementModal
          title="Woohoo! You’ve connected a channel"
          content="Your channel is connected! Create your first post to share with
                your new audience."
          modalImage={ConnectChannelIllus}
          handleCancel={() => setShowEngagementModal(false)}
          actionText="Create post"
          routeTo="/dashboard/posts/calendar-view?post_action=create_post"
        />
      )}

      <ConfirmModal
        id="confirmPlatformRemoval"
        action="remove this social media channel"
        description={`Removing this channel means you won't be able to post to it from PostPaddy.`}
        actionText="Remove"
        callback={() => removeSocial()}
      />

      {/* Connect guide request for instagram connection */}
      <ConnectGuide disabled={connecting} />

      {/* Connect guide check list */}
      <ConnectChecklist
        disabled={connecting}
        handleConnection={() => handleConnectPlatform("instagram")}
      />

      <InstagramAccountConvertInfo
        disabled={connecting}
        handleConnection={() => handleConnectPlatform("instagram")}
      />

      {/* Request call */}
      <RequestCall />

      {/* connect facebook info */}
      <ConnectFacebookInfo
        disabled={connecting}
        handleConnection={() => handleConnectPlatform("facebook")}
      />

      {/* tiktok connect info */}
      <ConnectTiktokInfo
        disabled={connecting}
        handleConnection={() => handleConnectPlatform("tiktok")}
      />

      {/* Connect to IG prompt */}
      <ConnectToIgPrompt
        handleConnection={() => handleConnectPlatform("instagram", true)}
        disabled={connecting}
      />

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="flexRow alignCenter">
            <GoBack />
            <Spacer x={1.2} />
            <div className="flexRow alignCenter">
              <ImgWrapper
                size={3.2}
                imgHeight={brand?.avatar ? "100%" : "2.4rem"}
              >
                {brand?.avatar ? (
                  <img src={`${brand?.avatar}`} alt="AVI" />
                ) : (
                  <img src={userIcon} alt="avatar" id="photoOutput" />
                )}
              </ImgWrapper>
              <Spacer x={1.2} />
              <h5 className="l1-large brandName">{brand?.name}</h5>
            </div>
          </div>
          <Spacer y={2.4} />
          <h5 className="colorGrey1 manageChannelPageTitle">
            Link brand's social media channels
          </h5>
          <Spacer y={0.6} yMobile={0.2} />
          <p className="l3 colorBodyText description">
            Connect your social media channels and enjoy seamless posting and
            scheduling.
          </p>
          <Spacer y={2.4} />
          <Channels
            socials={socials}
            platformList={platformList}
            brandId={brand?.id}
            handleConnectPlatform={handleConnectPlatform}
            handleTokenRefresh={handleTokenRefresh}
            handleRemoveChannel={handleRemoveChannel}
            toggleShowOptions={toggleShowOptions}
            openOptionId={openOptionId}
            connecting={connecting}
            showYoutubeModal={showYoutubeModal}
            setShowYoutubeModal={setShowYoutubeModal}
            removeSocial={removeSocial}
            active_account={active_account}
          />
          <Spacer y={2.4} />

          <Button
            type="button"
            text="Done"
            className="doneBtn"
            onClick={async () => {
              const redirectTo = redirect_url;
              router.push(redirectTo ?? `/dashboard/brands`);
              setRedirectUrl(null);
            }}
            disabled={!platformList?.length}
          />
        </>
      )}

      {/* Select account/page modal */}
      <Route
        exact
        path={`${path}/select-account`}
        component={() => (
          <SelectAccountModal
            brand={brand}
            path={path}
            loadSocials={loadSocials}
          />
        )}
      />

      {/* render connection failure modal when platform connection fails */}
      <ConnectionFailureModal />
    </ManageChannelsWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    active_account: state.active_account,
    current_sub: state.current_sub,
    user_token: state.user_token,
    redirect_url: state.redirect_url,
    active_brand: state.brand,
  };
};

export default connect(mapStateToProps)(ManageChannels);
